import constants from '@/app-configs/constants'

export default [
  {
    title: 'DEBTIA_TEMPLATES',
    icon: 'TypeIcon',
    action: constants.action.permissionEmailTemplateView,
    resource: constants.resource.template,
    children: [
      {
        title: 'DEBTIA_EMAIL_TEMPLATE',
        route: 'email-templates',
        action: constants.action.permissionEmailTemplateView,
        resource: constants.resource.emailTemplate,
      },
      {
        title: 'DEBTIA_SMS_TEMPLATE',
        route: 'sms-templates',
        action: constants.action.permissionSMSTemplateView,
        resource: constants.resource.smsTemplate,
      },
    ],
  },
]
